// 在檔案最上方加這段
declare const require: {
  context(
    path: string,
    deep?: boolean,
    filter?: RegExp,
  ): {
    keys(): string[]
    <T>(id: string): T
  }
}

type Locale = 'en' | 'zh'

function importAll(r: ReturnType<typeof require.context>) {
  const translations: Record<string, any> = {}
  r.keys().forEach((key) => {
    const ns = key.replace('./', '').replace('.json', '')
    translations[ns] = r(key)
  })
  return translations
}

const en = importAll(require.context('./en', false, /\.json$/))
const zh = importAll(require.context('./zh', false, /\.json$/))

export const resources: Record<Locale, Record<string, any>> = {
  en,
  zh,
}
